module.exports = __webpack_public_path__ + "b231d8191a8fd84e9078b0c161a88730.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/franchises/dow_image_mobile.jpg
// module id = 155
// module chunks = 0